import styled from 'styled-components';

export const FacetsContainer = styled.div`
  margin: 0;
  padding: 0;
`;
